<ng-container *ngIf="lineGroup" [formGroup]="lineGroup">
	<td>
		<button pButton pRipple type="button" icon="pi pi-pencil" class="p-button-rounded p-button-secondary p-button-text ms-0 d-md-none"
			(click)="isClosed = !isClosed"></button>
		<span class="p-column-title">#</span>
		{{ lineIndex + 1 }}
	</td>
	<td>
		<span class="p-column-title">{{ 'routes.document.product' | translate }}</span>
		<ng-container *ngIf="lineGroup.get('product_id') as productControl">
			<app-product-select [parentFormGroup]="lineGroup" [formControlInstance]="productControl"
				[label]="'routes.document.product' | translate" [required]="true" [submitted]="submitted"
				[debug]="debug" [productsList]="productsList" [companyId]="documentCompanyId"
				(productChange)="onProductSelection($event)">
			</app-product-select>
		</ng-container>
	</td>
	<td *ngIf="!(isClosed && isMobile)">
		<span class="p-column-title">{{ 'routes.document.description' | translate }}</span>
		<textarea rows="1" pInputTextarea type="text" formControlName="description" class="w-100"
			placeholder="{{ 'routes.document.description' | translate }}"></textarea>
	</td>
	<td>
		<span class="p-column-title">{{ 'routes.document.quantity' | translate }}</span>
		<p-inputNumber inputId="quantity-{{lineIndex}}" formControlName="quantity" mode="decimal"
			[minFractionDigits]="0" [maxFractionDigits]="3" [min]="0.1" [showButtons]="true"
			inputStyleClass="text-right w-100" [ngClass]="{'ng-invalid ng-dirty': isInvalid('quantity')}"
			placeholder="{{ 'routes.document.quantity' | translate }}" class="quantity"
			(onInput)="calculateTotals()"></p-inputNumber>
	</td>
	<td *ngIf="!(isClosed && isMobile)">
		<span class="p-column-title">{{ 'routes.document.pricePerUnit' | translate }}</span>
		<div class="p-inputgroup">
			<p-inputNumber inputId="price_per_unit-{{lineIndex}}" formControlName="price_per_unit" mode="decimal"
				[minFractionDigits]="2" [maxFractionDigits]="5" [min]="0" inputStyleClass="text-right w-100"
				[ngClass]="{'ng-invalid ng-dirty': isInvalid('price_per_unit')}" class="with-btn"
				placeholder="{{ 'routes.document.pricePerUnit' | translate }}"
				(onInput)="calculateTotals()"></p-inputNumber>
			<button type="button" pButton
				[icon]="lineGroup.get('isVatIncluded')?.value ? 'pi pi-check-circle' : 'pi pi-times-circle'"
				class="p-button-secondary p-button-sm" (click)="toggleVatIncluded()"
				[pTooltip]="lineGroup.get('isVatIncluded')?.value ? ('documentLines.incVat' | translate) : ('documentLines.excVat' | translate)"
				tooltipPosition="top">
			</button>
		</div>
		<small *ngIf="isInvalid('price_per_unit')" class="p-error">{{ getErrorMessage('price_per_unit') }}</small>
	</td>
	<td *ngIf="!(isClosed && isMobile)">
		<span class="p-column-title">{{ 'routes.document.discount' | translate }}</span>
		<div class="p-inputgroup">
			<p-inputNumber inputId="discount-{{lineIndex}}" formControlName="discount" mode="decimal"
				[minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" inputStyleClass="text-right"
				[ngClass]="{'ng-invalid ng-dirty': isInvalid('discount')}" class="with-btn"
				placeholder="{{ 'routes.document.discount' | translate }}"
				(onInput)="calculateTotals()"></p-inputNumber>
			<button type="button" pButton
				[icon]="lineGroup.get('discountType')?.value === 'percentage' ? 'pi pi-percentage' : 'pi pi-money-bill'"
				class="p-button-secondary p-button-sm" (click)="toggleDiscountType()"
				[pTooltip]="lineGroup.get('discountType')?.value === 'percentage' ? ('documentLines.discountTypePercentageTooltip' | translate) : ('documentLines.discountTypeFixedTooltip' | translate)"
				tooltipPosition="top"></button>
		</div>
		<small *ngIf="isInvalid('discount')" class="p-error">{{ getErrorMessage('discount') }}</small>
	</td>
	<td class="text-right" *ngIf="!(isClosed && isMobile)">
		<span class="p-column-title">{{ 'routes.document.subTotal' | translate }}</span>
		<p-inputNumber inputId="sub_total-{{lineIndex}}" formControlName="sub_total" mode="decimal"
			[minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" inputStyleClass="text-right w-100"
			[disabled]="true" placeholder="{{ 'routes.document.subTotal' | translate }}">
		</p-inputNumber>
	</td>
	<td class="text-right" *ngIf="!(isClosed && isMobile)">
		<span class="p-column-title">{{ 'routes.document.vatShort' | translate }}</span>
		<p-inputNumber inputId="vat_amount-{{lineIndex}}" formControlName="vat_amount" mode="decimal"
			[minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" inputStyleClass="text-right w-100"
			[disabled]="true" placeholder="{{ 'routes.document.vatShort' | translate }}">
		</p-inputNumber>
	</td>
	<td class="text-right fw-bold">
		<span class="p-column-title">{{ 'routes.document.total' | translate }}</span>
		<p-inputNumber inputId="total_amount-{{lineIndex}}" formControlName="total_amount" mode="decimal"
			[minFractionDigits]="2" [maxFractionDigits]="2" [min]="0" inputStyleClass="text-right w-100"
			[ngClass]="{'ng-invalid ng-dirty': isInvalid('total_amount')}"
			placeholder="{{ 'routes.document.total' | translate }}"
			(onInput)="onTotalAmountChange($event.value)"></p-inputNumber>
		<small *ngIf="isInvalid('total_amount')" class="p-error">{{ getErrorMessage('total_amount') }}</small>
	</td>
	<td>
		<span class="p-column-title">{{ 'routes.document.actions' | translate }}</span>
		<button pButton pRipple type="button" icon="pi pi-trash"
			class="p-button-rounded p-button-danger p-button-text m-auto" (click)="onRemoveLine()"></button>
	</td>
</ng-container>
<ng-container *ngIf="!lineGroup">
	<td colspan="10">Error: Line data not available.</td>
</ng-container>
